const doLog = (process.env.VUE_APP_LOG_ENABLED == 'y');
const MAX_STR = 70;
// log color
function lColor(v0, color, bgColor, ...vx) {
    console.log(`%c${v0}`, `background: ${bgColor}; color: ${color}`, ...vx);
}
function maxStr(str) {
    str = '' + str;
    if (str.length > MAX_STR) {
        return str.substr(0, MAX_STR) + '...';
    }
    return str;
}
// vuex store commits
function lCommit(mutation) {
    if (!doLog)
        return;
    if (mutation.payload === undefined) {
        console.log(`%c|%c C:`, `background: #fff; color: #000`, `background: #000; color: #ffff00`, mutation.type);
    }
    switch (typeof mutation.payload) {
        case "string":
            return console.log(`%c|%c C:`, `background: #fff; color: #000`, `background: #000; color: #ffff00`, mutation.type + '(' + maxStr(mutation.payload) + ')');
    }
    return console.log(`%c|%c C:`, `background: #fff; color: #000`, `background: #000; color: #ffff00`, mutation.type, mutation.payload);
}
// vuex store actions
function lAction(action) {
    if (!doLog)
        return;
    if (action.payload === undefined) {
        return lColor(` A >`, '#11ff11', '#000', action.type);
    }
    switch (typeof action.payload) {
        case "string":
            return lColor(` A >`, '#11ff11', '#000', action.type + '(' + maxStr(action.payload) + ')');
    }
    return lColor(` A >`, '#11ff11', '#000', action.type, action.payload);
}
function lCache(state, key) {
    if (!doLog)
        return;
    return lColor(`${state}`, '#1111ff', '#cc0', maxStr(key));
}
// alias
const logColor = lColor;
const logCommit = lCommit;
const logAction = lAction;
const logCache = lCache;
export default {
    color: logColor,
    commit: logCommit,
    action: logAction,
};
export { logColor, lColor, lCommit, logCommit, lAction, logAction, lCache, logCache };
